import React from 'react';
import Earth from './Earth';
import Navbar from '../Nav/Navbar.jsx';
import MenuBox from './MenuBox.jsx';
import Social from '../Socials/Social';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className='landing-page'>
      <Navbar />
      <Earth />
      <MenuBox />
      <Social />
    </div>
  );
};

export default LandingPage;
